"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var style_1 = require("../../../style");
var styles_1 = require("./styles");
var utils_1 = require("./utils");
var CustomSideContainer = function (_a) {
    var updateDates = _a.updateDates;
    return (react_1.jsx(layout_1.Flex, { direction: "column", gap: 4, css: styles_1.style.customSideContainer },
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates(utils_1.selectToday(), utils_1.selectToday()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "Today")),
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates(utils_1.selectYesterday(), utils_1.selectYesterday()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "Yesterday")),
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates.apply(void 0, utils_1.selectThisWeek()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "This week")),
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates.apply(void 0, utils_1.selectLastWeek()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "Last week")),
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates.apply(void 0, utils_1.selectThisMonth()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "This month")),
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates.apply(void 0, utils_1.selectLastMonth()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "Last month")),
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates.apply(void 0, utils_1.selectThisyear()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "This year")),
        react_1.jsx("div", { css: styles_1.style.sideText, onClick: function () { return updateDates.apply(void 0, utils_1.selectLastYear()); } },
            react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: {
                    '&:hover': {
                        color: "" + style_1.DesignSystemThemeColor.Primary.DARK_2,
                    },
                } }, "Last year"))));
};
exports.default = CustomSideContainer;
